// ThemeToggle.jsx - Composant toggle Light/Dark Mode
import React from 'react';
import { Button, Tooltip } from 'antd';
import { BulbOutlined, BulbFilled } from '@ant-design/icons';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = ({
  size = 'middle',
  showLabel = false,
  style = {},
  className = '',
}) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <Tooltip
      title={isDarkMode ? 'Activer le mode clair' : 'Activer le mode sombre'}
      placement="bottom"
    >
      <Button
        type="text"
        size={size}
        icon={isDarkMode ? <BulbFilled /> : <BulbOutlined />}
        onClick={toggleTheme}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          ...style,
        }}
        className={`theme-toggle-btn ${className}`}
        aria-label={isDarkMode ? 'Mode clair' : 'Mode sombre'}
      >
        {showLabel && (isDarkMode ? 'Mode Clair' : 'Mode Sombre')}
      </Button>
    </Tooltip>
  );
};

export default ThemeToggle;
